<template>
  <div class="interface">
    <!-- 导航栏 -->
    <!-- <div class="navigation">
      <div class="back" @click="Previouspage()"><<<</div>
      <img :src="logUrlList.home" class="home_img" @click="Maininterface()" />
    </div> -->
    <div class="cut">
      <vue-cropper
        ref="cropper"
        :img="option.img"
        :output-size="option.size"
        :output-type="option.outputType"
        :info="option.info"
        :full="option.full"
        :fixed="option.fixed"
        :fixed-number="option.fixedNumber"
        :can-move="option.canMove"
        :can-move-box="option.canMoveBox"
        :fixed-box="option.fixedBox"
        :original="option.original"
        :auto-crop="option.autoCrop"
        :auto-crop-width="option.autoCropWidth"
        :auto-crop-height="option.autoCropHeight"
        :center-box="option.centerBox"
        :canScale="option.canScale"
        :enlarge="option.enlarge"
        @real-time="realTime"
        :high="option.high"
        @img-load="imgLoad"
        mode="100%"
        :maxImgSize="option.max"
        style="background-image: none"
      >
      </vue-cropper>
    </div>
    <!-- 编辑部分 -->
    <div class="editor_part">
      <!-- 横竖版 -->
      <div class="direction">
        <van-radio-group v-model="cardOri" direction="horizontal">
          <van-radio name="0">横版</van-radio>
          <van-radio name="1">竖版</van-radio>
        </van-radio-group>
      </div>
      <!-- 放大缩小/旋转 -->

      <div class="editor_button_arr">
        <div class="editor_button">
          <div
            class="editor_button_zoom"
            :class="{ active: !isActive_zoom }"
            @click="zoom()"
          >
            缩放
          </div>
          <div
            class="editor_button_rotation"
            :class="{ active: !isActive_rotation }"
            @click="rotation()"
          >
            旋转
          </div>
        </div>
        <!-- 放大、缩小 -->
        <div class="rotation_arr" v-if="editorArr">
          <!-- <div class="zoom_arr01">
            <van-slider
              v-model="changeScaledata"
              @change="changeScale(changeScaledata)"
              :min="-50"
              :max="50"
            />
          </div> -->
          <!-- 放大 -->
          <div class="rotation_left01" @click="changeScale(1)">
            <img :src="logUrlList.zoom" class="rotation_left01_image" />
            <div class="rotation_left01_name">放大</div>
          </div>
          <!-- 缩小 -->
          <div class="rotation_left01" @click="changeScale(-1)">
            <img :src="logUrlList.zoom" class="rotation_right01_image" />
            <div class="rotation_right01_name">缩小</div>
          </div>
        </div>
        <!-- 旋转 -->
        <div class="rotation_arr" v-if="!editorArr">
          <!-- 左旋 -->
          <div class="rotation_left02" @click="rotateLeft()">
            <img
              :src="logUrlList.rotation_left01"
              class="rotation_left01_image"
            />
            <div class="rotation_left01_name">左旋</div>
          </div>
          <!-- 右旋 -->
          <div class="rotation_right01" @click="rotateRight()">
            <img
              :src="logUrlList.rotation_right01"
              class="rotation_right01_image"
            />
            <div class="rotation_right01_name">右旋</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="button_part" @click="cropImage()">完成</div> -->
    <div class="button_part">
      <div class="button_left" @click="Previouspage()">←上一步</div>
      <div class="button_right" @click="cropImage()">选择背景→</div>
    </div>
    <!-- 白边提示 -->
    <b-modal ok-only ref="model_tip" title="提示" ok-title="确定" centered>
      <p class="my-4">截图框内不能留有空白，请放大或缩小图片</p>
    </b-modal>
    <!-- 错误提示 -->
    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
      centered
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>
    <!-- 上传图片 -->
    <b-modal
      ok-only
      ref="model_error_imgPath"
      title="提示"
      @ok="handleOkimgPath"
      ok-title="确定"
      centered
    >
      <p class="my-4">{{ errorMsg }}</p></b-modal
    >
  </div>
</template>
<script>
import "cropperjs/dist/cropper.css";
const logUrl = require("@/common/logUrl");
const config = require("@/common/config");
export default {
  name: "AIEditCardface_ccb",
  data() {
    return {
      logUrlList: logUrl.logUrl,
      imgPath: "", //需要编辑的图片
      option: {
        img: "",
        size: 1,
        info: false,
        full: true,
        outputType: "png",
        canMove: true,
        fixedBox: true,
        original: false,
        canMoveBox: false,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 160,
        autoCropHeight: 150,
        centerBox: false,
        high: true,
        max: 2000,
        fixed: true,
        fixedNumber: [8.62, 5.46], //5.46*8.62
        canScale: true,
        enlarge: 1,
      },
      cardOri: "0", //横竖版
      isActive_zoom: true, // 初始状态:缩放
      isActive_rotation: false, // 初始状态:缩放
      editorArr: true, //编辑区域
      taskId: "",
      bankSerialNumber: "",
      bankCode: "",
      cardTheme: "",
      style: "",
      errorMsg: "",
      changeScaledata: 0,
      process: "",
      processCollection: "",
    };
  },
  watch: {
    cardOri(newval, oldval) {
      console.log("newval：" + newval, "oldval：" + oldval);
      if (newval == "1") {
        this.option.autoCropWidth = 186;
        this.option.autoCropHeight = 331;
        this.option.fixedNumber = [5.46, 8.62]; //[8.62, 5.46]
        console.log("this.option.fixedNumber", this.option.fixedNumber);
      } else {
        this.option.autoCropWidth = 331;
        this.option.autoCropHeight = 186;
        this.option.fixedNumber = [8.62, 5.46]; //[8.62, 5.46]
        console.log("this.option.fixedNumber", this.option.fixedNumber);
      }
    },
  },
  methods: {
    zoom() {
      this.isActive_zoom = true;
      this.isActive_rotation = false;
      this.editorArr = true;
    },
    rotation() {
      this.isActive_zoom = false;
      this.isActive_rotation = true;
      this.editorArr = false;
    },
    Previouspage() {
      if (this.process == 0) {
        // 文生图
        this.$router.replace({
          name: "AItext_to_image_ccb",
          params: {
            taskId: this.taskId,
            // phone: this.phone,
            backoff: 1,
          },
        });
      } else if (this.process == 1) {
        // 图文生图
        this.$router.replace({
          name: "AIimage_text_to_image_ccb",
          params: {
            taskId: this.taskId,
            // phone: this.phone,
            backoff: 1,
            style: this.style,
            prompt: this.prompt,
          },
        });
      } else if (this.process == 2) {
        // 图生图
        this.$router.replace({
          name: "AIimage_to_image_ccb",
          params: {
            taskId: this.taskId,
            // phone: this.phone,
            backoff: 1,
            style: this.style,
          },
        });
      } else {
        // 退回主页面
        this.$router.replace({
          name: "",
          params: {
            taskId: this.taskId,
            // phone: this.phone,
            backoff: 1,
          },
        });
      }
    },
    Maininterface() {
      this.$router.replace({
        name: "home_ccb",
      });
    },
    refreshCrop() {
      // clear
      this.$refs.cropper.refresh();
    },
    changeScale(num) {
      num = num || 50;
      this.$refs.cropper.changeScale(num);
    },

    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
    // 实时预览函数
    realTime(data) {
      console.log("realTime");
      let w = this.$refs.cropper.cropW;
      let h = this.$refs.cropper.cropH;
      // 图片缩放比例
      let scale = this.$refs.cropper.scale;
      // 图片偏移x轴
      let x = this.$refs.cropper.x;
      // 图片偏移y轴
      let y = this.$refs.cropper.y;
      // 图片真实宽度
      let trueWidth = this.$refs.cropper.trueWidth;
      // 图片真实高度
      let trueHeight = this.$refs.cropper.trueHeight;
      // 裁剪框的坐标轴
      let cropX = this.$refs.cropper.cropX;
      let cropY = this.$refs.cropper.cropY;

      console.log("截图框宽高：" + w + "*" + h);
      console.log("图片缩放比例：" + scale);
      console.log("图片偏移x轴：" + x);
      console.log("图片偏移y轴：" + y);
      console.log("图片真实宽度：" + trueWidth);
      console.log("图片真实高度：" + trueHeight);
      console.log("裁剪框的坐标轴：" + cropX + "*" + cropY);

      console.log(data);
    },
    imgLoad(msg) {
      console.log(msg);
      // 图片初始缩放比例
      let scale = this.$refs.cropper.scale;
      this.initScale = scale;
      let cropperObj = this.$refs.cropper;
      let maxWidth = cropperObj.w;
      let maxHeight = cropperObj.h;
      let imgW = cropperObj.trueWidth * cropperObj.scale;
      let imgH = cropperObj.trueHeight * cropperObj.scale;
      maxWidth = imgW < maxWidth ? imgW : maxWidth;
      maxHeight = imgH < maxHeight ? imgH : maxHeight;

      console.log("maxWidth:" + maxWidth);
      console.log("maxHeight:" + maxHeight);
      console.log("imgW:" + imgW);
      console.log("imgH:" + imgH);
      console.log("maxWidth:" + maxWidth);
      console.log("maxWidth:" + maxWidth);
      console.log("initScale:" + this.initScale);

      if (this.cardOri == 0) {
        //横版
        this.option.autoCropWidth = maxWidth * 0.9;
        this.option.autoCropHeight = (maxWidth * 0.9 * 9) / 16;
        console.log("autoCropWidth:" + this.option.autoCropWidth);
        console.log("autoCropHeight:" + this.option.autoCropHeight);
        this.option.fixedNumber = [8.62, 5.46]; //[5.46, 8.62]; //[8.62, 5.46]
      } else if (this.cardOri == 1) {
        //竖版
        this.option.autoCropWidth = (maxHeight * 0.9 * 9) / 16;
        this.option.autoCropHeight = maxHeight * 0.9;
        console.log("autoCropWidth:" + this.option.autoCropWidth);
        console.log("autoCropHeight:" + this.option.autoCropHeight);
        this.option.fixedNumber = [5.46, 8.62];
      }
    },
    hasWhiteSpace: function () {
      let has = true;
      let axis = this.$refs.cropper.getImgAxis();
      let cropAxis = this.$refs.cropper.getCropAxis();
      console.log(axis);
      console.log(cropAxis);

      // 左边的横坐标 图片不能超过截图框
      if (axis.x1 >= cropAxis.x1) {
        has = false;
      }
      // 右边横坐标
      if (axis.x2 <= cropAxis.x2) {
        has = false;
      }
      // 纵坐标上面
      if (axis.y1 >= cropAxis.y1) {
        has = false;
      }
      // 纵坐标下面
      if (axis.y2 <= cropAxis.y2) {
        has = false;
      }
      return has;
    },
    cropImage: function () {
      var that = this;
      let has = that.hasWhiteSpace();
      if (!has) {
        that.showCropTip();
        return;
      }
      // 获取截图的blob数据
      this.$refs.cropper.getCropBlob((data) => {
        console.log(data);
        let url = window.URL.createObjectURL(data);
        this.targetImg = url;
        console.log("blob url:" + url);
        let image = new Image();
        let w, h;
        image.src = url;
        image.onload = function () {
          w = image.width; // 图片宽度
          h = image.height; // 图片高度
          image.onload = null; // 避免重复加载
          console.log("图片宽高:" + w + "*" + h);
          that.toUploadCardface();
        };
      });
    },
    toUploadCardface() {
      localStorage.setItem("cardOri_ccb", this.cardOri);
      localStorage.setItem("targetImg_ccb", this.targetImg);
      this.$router.replace({
        name: "SelectReverseSide_ai_ccb",
        params: {
          delImageUrl: this.delImageUrl,
          taskId: this.taskId,
          process: this.process,
          // phone: this.phone,
          prompt: this.prompt,
        },
      });
    },
    showCropTip: function () {
      this.$refs["model_tip"].show();
    },
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    showErrorMsg_image: function () {
      this.$refs["model_error_imgPath"].show();
    },
    handleOk: function (bvModalEvt) {},
    handleOkimgPath() {
      this.Previouspage();
      // this.$router.replace({
      //   name: "AISelectCardface_ccb",
      // });
    },
  },
  mounted() {
    this.imgPath = this.$route.params.imagePath;
    console.log("imgPath:" + this.imgPath);
    if (this.imgPath == undefined) {
      this.errorMsg = "请重新生成图片";
      this.showErrorMsg_image();
    }

    this.option.img = this.imgPath;
    this.delImageUrl = this.$route.params.delImageUrl;
    console.log("delImageUrl:" + this.delImageUrl);
    this.bankSerialNumber = localStorage.getItem("bankSerialNumber");
    this.phone = localStorage.getItem("phone");
    this.process = this.$route.params.process;
    this.processCollection = this.$route.params.processCollection;
    console.log("process" + this.process);
    this.taskId = this.$route.params.taskId;
    console.log("taskId" + this.taskId);
    this.style = this.$route.params.style;
  },
};
</script>

<style scoped>
.navigation {
  position: fixed;
  z-index: 1000;
  width: 100%;
  background: linear-gradient(left, #3861d5, white);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 2rem;
}
.home_img {
  width: 1.8rem;
}
.back {
  font-size: 1.2rem;
  font-weight: 700;
  color: white;
}
/* 页面主体内容 */
.subject {
  padding: 1.8rem 1.8rem 0;
  /* background-color: pink; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/* .header {
  background-color: aqua;
  height: 3rem;
} */
/* .main {
  background-color: yellow;
  height: 3rem;
} */
.cut {
  width: 100vw;
  height: 60vh;
}
.editor_part {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.direction {
  width: 100%;
  height: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: #00000050;
}
.editor_button_arr {
  width: 100%;
}
.editor_button {
  width: 100%;
  height: 2.8rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
/* ------ */
.editor_button_zoom {
  width: 50%;
  height: 2.8rem;
  background-color: white;
  color: #3861d5;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.editor_button_zoom.active {
  background-color: #00000050;
  font-size: 0.8rem;
  font-weight: 400;
  color: black;
}
.editor_button_rotation {
  width: 50%;
  height: 2.8rem;
  background-color: white;
  color: #3861d5;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.editor_button_rotation.active {
  background-color: #00000050;
  font-size: 0.8rem;
  font-weight: 400;
  color: black;
}
.zoom_arr {
  width: 100%;
  height: 8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 2rem;
}
.zoom_arr01 {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
/* .zoom_arr_name {
} */
.rotation_arr {
  width: 100%;
  height: 8rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 4rem;
}
.rotation_left01 {
  width: 4rem;
  height: 4rem;
  /* border: #3861d5 dashed 1px; */
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.rotation_left02 {
  width: 4rem;
  height: 4rem;
  border: #3861d5 dashed 1px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.rotation_left01_image {
  width: 2rem;
}
.rotation_left01_name {
  color: #3861d5;
  font-size: 1rem;
  font-weight: 600;
}
.rotation_right01 {
  width: 4rem;
  height: 4rem;
  border: #3861d5 dashed 1px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.rotation_right01_image {
  width: 2rem;
}
.rotation_right01_name {
  color: #3861d5;
  font-size: 1rem;
  font-weight: 600;
}
/* .footer {
  background-color: blue;
  height: 3rem;
} */
.button_part {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 0 1rem;
}
.button_left {
  width: 40%;
  height: 2.6rem;
  border: 1px solid #023bb6;
  border-radius: 1.3rem;
  color: #023bb6;
  font-weight: 700;
  font-size: 1rem;
  text-align: center;
  padding-top: 0.4rem;
}
.button_right {
  width: 50%;
  height: 2.6rem;
  border-radius: 1.3rem;
  background: linear-gradient(to right, #093695, #0d1632);
  color: #ffffff;
  font-weight: 700;
  font-size: 1rem;
  text-align: center;
  padding-top: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/CCB_demo/AIGC/AIEditCardface.vue